import { Button, Dialog, DialogDescription, DialogTitle } from 'components/Elements';
import { Form, UploadField } from 'components/Form';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUpdateAvatar } from '../api/updateAvatar';
import { useAuth } from 'lib/auth';
import { Logo } from 'components/Layout';
import { PenTool } from 'react-feather';

export const UpdateAvatarIcon = ({ requireUpdate }) => {
  const navigate = useNavigate();

  const [show, setShow] = React.useState(false);
  const [avatar, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const updateAvatarMutation = useUpdateAvatar();

  const { user } = useAuth();

  useEffect(() => {
    if (requireUpdate) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {};

  return (
    <Dialog isOpen={show} onClose={handleClose} initialFocus={null}>
      <div className="inline-block align-bottom bg-white rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
        <DialogTitle className="flex flex-row items-center justify-center font-bold mb-4">
          <Logo />
        </DialogTitle>
        <DialogDescription>
          <div>
            <Form
              id="update-avatar"
              onSubmit={async (values) => {
                const bodyFormData = new FormData();
                bodyFormData.append('avatar', avatar);
                await updateAvatarMutation.mutateAsync({ data: bodyFormData, id: user._id });
                setPreview(null);
              }}
              options={{
                defaultValues: {
                  avatar: user.basicInformation?.avatar,
                },
              }}
            >
              {({ register, formState }) => (
                <>
                  <UploadField
                    title="Profile picture"
                    error={formState.errors['avatar']}
                    caption="A picture helps improve your credit rating and let's lenders recognize you."
                    onChange={(e) => {
                      setImage(e.target.files[0]);
                      setPreview(URL.createObjectURL(e.target.files[0]));
                    }}
                    button={
                      <button
                        type="button"
                        onClick={() => {
                          setPreview(null);
                        }}
                        className="text-red-500 cursor-pointer"
                      >
                        Remove
                      </button>
                    }
                    preview={preview}
                  />
                  <Button
                    isLoading={updateAvatarMutation.isLoading}
                    type="submit"
                    startIcon={<PenTool className="w-4 h-4" />}
                    className="mt-4 p-2 px-4 bg-gray-100 w-full rounded-2xl text-white bg-secondary-100"
                  >
                    Update
                  </Button>
                </>
              )}
            </Form>
          </div>
        </DialogDescription>
      </div>
    </Dialog>
  );
};
